import { tr } from "@faker-js/faker";
import React from "react";

const CustomerSalesAnalysisTable = ({ data }: { data: any }) => {
  const monthKeys = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const monthlyTotals = monthKeys.map((month) =>
    data?.reduce((sum: any, row: any) => sum + (Number(row[month]) || 0), 0)
  );

  const totalOfTotals = data?.reduce(
    (sum: any, row: any) => sum + (Number(row.Total) || 0),
    0
  );

  return (
    <div className="overflow-x-auto h-[900px]">
      <table className="table-auto border border-gray-300 w-full min-w-[700px] text-sm">
        <thead className="bg-gray-100 sticky top-0">
          <tr>
            <th className="px-4 py-2 border text-left">Customer</th>
            <th className="px-4 py-2 border text-left">Bu</th>
            <th className="px-4 py-2 border text-left">Frequency</th>
            <th className="px-4 py-2 border text-left">January</th>
            <th className="px-4 py-2 border text-left">February</th>
            <th className="px-4 py-2 border text-left">March</th>
            <th className="px-4 py-2 border text-left">April</th>
            <th className="px-4 py-2 border text-left">May</th>
            <th className="px-4 py-2 border text-left">June</th>
            <th className="px-4 py-2 border text-left">July</th>
            <th className="px-4 py-2 border text-left">August</th>
            <th className="px-4 py-2 border text-left">September</th>
            <th className="px-4 py-2 border text-left">October</th>
            <th className="px-4 py-2 border text-left">November</th>
            <th className="px-4 py-2 border text-left">December</th>
            <th className="px-4 py-2 border text-left">Total</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data?.map((dtl: any) => {
              return (
                <tr>
                  <td className="px-4 py-2 border">{dtl.customer_name}</td>
                  <td className="px-4 py-2 border">{dtl.business_unit_name}</td>
                  <td className="px-4 py-2 border">{dtl.Frequency}</td>
                  <td className="px-4 py-2 border ">{dtl.January}</td>
                  <td className="px-4 py-2 border ">{dtl.February}</td>
                  <td className="px-4 py-2 border ">{dtl.March}</td>
                  <td className="px-4 py-2 border ">{dtl.April}</td>
                  <td className="px-4 py-2 border ">{dtl.May}</td>
                  <td className="px-4 py-2 border ">{dtl.June}</td>
                  <td className="px-4 py-2 border ">{dtl.July}</td>
                  <td className="px-4 py-2 border ">{dtl.August}</td>
                  <td className="px-4 py-2 border ">{dtl.September}</td>
                  <td className="px-4 py-2 border ">{dtl.October}</td>
                  <td className="px-4 py-2 border ">{dtl.November}</td>
                  <td className="px-4 py-2 border ">{dtl.December}</td>
                  <td className="px-4 py-2 border ">{dtl.Total}</td>
                </tr>
              );
            })}
        </tbody>
        <tfoot className=" sticky bottom-0">
          <tr className="bg-gray-200 font-semibold">
            <td className="px-4 py-2 border" colSpan={3}>
              Monthly Totals
            </td>
            {monthlyTotals.map((total, index) => (
              <td key={index} className="px-4 py-2 border">
                {total}
              </td>
            ))}
            <td className="px-4 py-2 border">{totalOfTotals}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default CustomerSalesAnalysisTable;
